module.exports = __webpack_public_path__ + "img/scanCodeWZ_border.a1e2cb7f.jpg";